<div
  class="wrapper"
  [ngClass]="{ width100: !isQuick }"
  ignoreClass="quickLoad"
  (glClickedOutside)="close()"
  >
  <div class="searchWrapper" [ngClass]="{ quick: isQuick }">
    <gl-search-input (searchChange)="onSearch($event)" autocomplete="off"></gl-search-input>
    <div class="buttonContainer">
      <button
        data-ctx="button-sort-by-name"
        class="sortButton"
        outline-icon-button
        (click)="sortByNameSwitch()"
        [class.activeSortByName]="isSortByNameEnabled"
        >
        <gl-icon class="sortIcon" [name]="'sort'"></gl-icon>
      </button>

      <button class="close" outline-icon-button (click)="close()" data-ctx="button-close">
        <gl-icon name="close"></gl-icon>
      </button>
    </div>
  </div>

  <div class="container" @disabledInitial data-ctx="container-create-load">
    @if (isListVisible) {
      <div @width>
        @if (!isQuick) {
          <div class="createLoadContainer">
            <div class="createCube">
              <div
                data-ctx="button-create-cube"
                (click)="createLoad(0)"
                class="ownVehicle"
                [class.notPremium]="!user?.isPremium"
                [glPremium]="true"
                >
                <div class="ownVehicleDescription">
                  <div class="ownVehicleText">{{ 'create_own' | translate }}</div>
                  @if (!user?.isPremium) {
                    <div class="pro">{{ 'PRO wersja' | translate }}</div>
                  }
                </div>
                <gl-icon class="ownVehicleIcon greyIcon" name="cubeIco"></gl-icon>
              </div>
            </div>
            @if (!isQuick) {
              <div class="createPipe">
                <div
                  data-ctx="button-create-pipe"
                  (click)="createLoad(2)"
                  class="ownVehicle"
                  [class.notPremium]="!user?.isPremium"
                  [glPremium]="true"
                  >
                  <gl-icon class="ownVehicleIcon" name="pipeIco"></gl-icon>
                </div>
              </div>
            }
            @if (!isQuick) {
              <div  class="createBarrel">
                <div
                  data-ctx="button-create-barrel"
                  (click)="createLoad(1)"
                  class="ownVehicle"
                  [class.notPremium]="!user?.isPremium"
                  [glPremium]="true"
                  >
                  <gl-icon class="ownVehicleIcon" name="barrelIco"></gl-icon>
                </div>
              </div>
            }
          </div>
        }
        <div class="loadContainer" data-ctx="container-load">
          <div class="loadWrapper">
            @for (load of loads; track trackByFunction($index, load)) {
              <div class="load" data-ctx="container-load-list-element">
                @if (load.show) {
                  <gl-load-list-element
                    (addLoadEvent)="quickAddLoad($event)"
                    (chosen)="onChosen($event)"
                    (edit)="editLoad($event)"
                    [hoverActive]="isFormDisabled()"
                    [individualAddBlocked]="isIndividualLoadListAddBlocked()"
                    [load]="load"
                    [isQuick]="isQuick"
                  ></gl-load-list-element>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (!isQuick) {
      <div class="heightLine" [class.removeLeftMargin]="!isListVisible">
        <div class="hideButton" (click)="listVisibleChanger()" data-ctx="button-hide">
          <gl-icon name="undo" class="hideIcon" [class.rightIcon]="!isListVisible"></gl-icon>
        </div>
      </div>
    }

    <div class="rightContainer" [ngClass]="{ hideRightContainer: isQuick }">
      <div [class.disabled]="isCreatingNewLoad" class="mainDimensions">
        <div class="visualization">
          <gl-load-preview
            [height]="190"
            [loadData]="loadDataVis"
            [project]="project"
            [width]="230"
          ></gl-load-preview>
        </div>

        <gl-load-dimensions
          #dimensions
          (submitForm)="addLoads($event)"
          (formData)="onFormData($event)"
          (resetForm)="resetForm()"
          (initialDimensions)="initialDimensions()"
          (layerCreateRequest)="onLayerCreateRequest()"
          (fillPalletRequest)="onFillPalletRequest()"
          (changeStackingOptions)="setFormationStackingOptions($event)"
          [chosenLoad]="currentLoad"
          [setActive]="isEdit"
          [loads]="loads"
          [currentType]="currentType"
          [isPalletLoadingSpaceActive]="isPalletLoadingSpaceActive()"
          [hasLoadedPalletLayers]="activeCargoSpaceHasLoadedPalletLayers()"
          [quantityLockedForLayers]="isQuantityInputLocked()"
          [individualAddBlocked]="isIndividualAddBlocked()"
          [showPalletLayerActions]="showPalletLayerActions()"
          [showFillPalletAction]="showFillPalletAction()"
          [highlightAddButton]="highlightAddButton && !isLayerCalculationStale()"
          [isLayerCalculationStale]="isLayerCalculationStale()"
          (changeLoadType)="openLoadType($event)"
          class="loadDimensions"
          (click)="enableEdit()"
        ></gl-load-dimensions>
      </div>

      <div [class.disabled]="!isCreatingNewLoad">
        <gl-load-chooser (type)="chooseType($event)"></gl-load-chooser>
      </div>

      <div class="tabs" data-ctx="container-tabs">
        <div (click)="openTab('preview')" [ngClass]="{ active: isTabPreview }" class="tab">
          <gl-icon [name]="'projectPreview'" class="projectPreviewIcon"></gl-icon>
        </div>
        @if (!activeCargoSpaceHasLoadedPalletLayers() && !quantityLockedForLayers) {
          <div (click)="openTab('stacking')" [ngClass]="{ active: isTabStacking }" class="tab">
            <div class="tabText">{{ 'stack' | translate }}</div>
          </div>
        }
        @if (supportsPalletLayerLoadType(loadData?.loadType) && isPalletLoadingSpaceActive()) {
          <div
            (click)="onInterlayersTabClick()"
            [ngClass]="{
              active: isTabInterlayers,
              tabDisabled: user?.isPremium && !showArrangementTab
            }"
            [glPremium]="true"
            class="tab"
            data-ctx="tab-interlayers"
            >
            <div class="tabText">{{ 'interlayers_tab' | translate }}</div>
          </div>
        }
        @if (loadData?.loadType !== 1) {
          <div
            (click)="openTab('rotate')"
            [ngClass]="{ active: isTabRotate }"
            class="tab"
            >
            <div class="tabText">{{ 'rotate_option' | translate }}</div>
          </div>
        }
        @if (!activeCargoSpaceHasLoadedPalletLayers() && !quantityLockedForLayers) {
          <div
            (click)="openTab('gravityOfCenter')"
            [ngClass]="{ active: isTabGravityOfCenter }"
            class="tab"
            >
            <div class="tabText">{{ 'gravity_center_load' | translate }}</div>
          </div>
        }
        @if (isCurrentMultiStopWorkSpace()) {
          <div
            data-ctx="loadingPlacesTab"
            (click)="openTab('loadingPlaces')"
            [ngClass]="{ active: isTabLoadingPlaces }"
            class="tab"
            >
            <div class="tabText">{{ 'loading_place' | translate }}</div>
          </div>
        }
      </div>
      @if (isTabPreview) {
        <div class="tabContent">
          @if (showArrangementTab) {
            <div class="previewArrangementLayout">
              <div class="previewArrangementColumn">
                <gl-load-pallet-arrangement
                  [layers]="arrangementLayers"
                  [loadLength]="loadData?.length"
                  [loadWidth]="loadData?.width"
                  [loadHeight]="loadData?.height"
                  [loadWeight]="loadData?.weight"
                  [selectedLayerId]="selectedPalletLayerId"
                  [layerCounts]="arrangementLayerCounts"
                  (layerSelected)="onPalletLayerSelected($event)"
                  (layerCountsChange)="onArrangementLayerCountsChange($event)"
                ></gl-load-pallet-arrangement>
              </div>
              <div class="previewProjectColumn">
                <div class="projectPreviewContainer">
                  <gl-project-preview
                    [height]="373"
                    [project]="project"
                    [width]="460"
                    [currentWorkspace]="currentWorkSpace"
                    [currentStopIndex]="currentStopIndex"
                    [is2Dimage]="true"
                    [pendingPalletLayer]="selectedArrangementLayer"
                    [pendingPalletLayersToAdd]="1"
                    [arrangementLayerPreviewCamera]="true"
                    [pendingLoadColor]="loadData?.color"
                    [pendingLoadType]="loadData?.loadType ?? 0"
                    [pendingLoadName]="loadData?.name"
                    [pendingLoadWeight]="loadData?.weight"
                    [pendingLoadDimensions]="pendingLoadDimensionsForPreview"
                    [pendingInterlayer]="arrangementPreviewInterlayer"
                  ></gl-project-preview>
                </div>
              </div>
            </div>
          } @else {
            <div class="projectPreviewContainer" (click)="previewClick()">
              <gl-project-preview
                [height]="373"
                [project]="project"
                [width]="714"
                [currentWorkspace]="currentWorkSpace"
                [currentStopIndex]="currentStopIndex"
                [is2Dimage]="true"
              ></gl-project-preview>
            </div>
          }
        </div>
      }
      @if (isTabStacking && !activeCargoSpaceHasLoadedPalletLayers() && !quantityLockedForLayers) {
        <div class="tabContent">
          <gl-load-stacking
            [loadData]="loadData"
            (stackingOptions)="setStackingOptions($event)"
            [savedStackingOptions]="stackingOptions"
          ></gl-load-stacking>
        </div>
      }
      @if (isTabRotate) {
        <div class="tabContent">
          <gl-load-rotate
            data-ctx="load-rotate"
            (rotateOptions)="onRotateOptionsChange($event)"
            [savedRotateOptions]="rotateOptions"
            (allowOutOfSpaceOption)="setAllowOutOfSpace($event)"
            [savedallowOutOfSpace]="allowOutOfSpace"
            [loadData]="loadData"
            [currentCargoSpace]="project?.workSpaces[currentWorkSpace]?.cargoSpaces"
          ></gl-load-rotate>
        </div>
      }
      @if (isTabGravityOfCenter && !activeCargoSpaceHasLoadedPalletLayers() && !quantityLockedForLayers) {
        <div class="tabContent">
          <gl-load-gravity-of-center
            [loadData]="loadData"
            (centerOfMass)="setCenterOfMass($event)"
            [defaultValue]="centerOfMassValue ?? centerOfMass"
          ></gl-load-gravity-of-center>
        </div>
      }
      @if (isTabLoadingPlaces) {
        <div class="tabContent">
          @if (project?.workSpaces[currentWorkSpace]?.stops?.length > 0) {
            <gl-load-loading-places
              (loadingPlacesOptions)="setLoadingPlacesOptions($event)"
              [defaultValue]="loadingPlacesOptions"
            ></gl-load-loading-places>
          }
        </div>
      }
      @if (supportsPalletLayerLoadType(loadData?.loadType) && isPalletLoadingSpaceActive()) {
        <div class="tabContent" [class.tabContentHidden]="!isTabInterlayers">
          <gl-load-interlayers
            #interlayersRef
            [disabled]="!showArrangementTab"
            [isPallet]="isPalletLoadingSpaceActive()"
            [layerQuantity]="effectivePalletLayerCount"
            [savedInterlayerLoads]="interlayerSavedLoads"
            [preferUnderFirstLayer]="activeCargoSpaceHasLoadedPalletLayers()"
          ></gl-load-interlayers>
        </div>
      }
    </div>
  </div>
</div>
